(ns bp-clients.tv-app.utils.indexdb
  "This project uses indexed db browser API because
  we use worker threads, that don't have access to local
  storage, since it is a window property."
  (:require [indexed.db :as db]))

(defn- handle-upgrade
  "When you create a new database or increase the 
   version number of an existing database (by specifying
   a higher version number than you did previously, when
   Opening a database), the onupgradeneeded event will 
   be triggered.

  See docs: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB#creating_or_updating_the_version_of_the_database"
  [upgrade-fn]
  (fn [e]
    (let [event   (db/create-version-change-event e)
          request (db/get-request event)]
      (upgrade-fn (db/result request) (db/get-transaction request)))))

(defn open
  [db-name db-version {:keys [upgradeneeded success blocked error] :or {upgradeneeded constantly error #(throw %) blocked #(throw %)}}]
  (let [open-request (db/open db-name db-version)]
    (-> (db/on open-request "error" #(throw %))
        (db/on "upgradeneeded" (handle-upgrade upgradeneeded))
        (db/on "error" error)
        (db/on "blocked" blocked)
        (db/on "success" #(success (db/result open-request))))))

(defn transaction
  ([db mode]
   (db/transaction db (db/object-store-names db) mode))
  ([db]
   (transaction db "readonly")))

(defn store
  ([db store-name mode]
   (db/object-store (transaction db mode) store-name))
  ([db store-name]
   (store db store-name "readonly")))

(defn create-db
  "Create a task db used for testing. This schema matches
   the todo list store modeled at MDN. Result of connection will be stored in the *db atom"
  [*db done {:db/keys [name version table]}]
  (open
   name
   version
   {:success
    (fn [idb]
      (reset! *db (db/create-database idb))
      (done))

    :upgradeneeded
    (fn [idb]
      (let [db    (db/create-database idb)]
        (db/create-object-store db table #_{:key-path user-api-key})))

    :blocked
    (fn []
      (db/close @*db))

    :error
    (fn []
      (println "Failed test connection")
      (done))}))

(defn event->request
  [e]
  (-> (.-target e)
      (db/create-request)
      (db/result)
      (js->clj)))

(def put db/put)
(def on db/on)
(def get-value db/get)
(def result event->request)
